import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './index.scss';
const cx = classnames.bind(styles);
const NotAvailable = ({ text }) => (_jsx("div", { className: cx('not-available-blank'), children: _jsx("div", { className: cx('not-available-text'), children: text }) }));
NotAvailable.propTypes = {
    text: PropTypes.string,
};
export default NotAvailable;
//# sourceMappingURL=index.js.map